(function () {
    'use strict';
    const MIN_SUBMISSION_COUNT = 20;
    class LeadsInsightsController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor(
            $scope,
            $injector,
            $translate,
            UiPersistenceService,
            CompaniesManager,
            UIUtils,
            Enums,
            AnalyticsService,
            AppStates,
            $state
        ) {
            super($scope, $injector, $translate);

            
            this.__objectType = 'LeadsInsightsController'; 

            this.$translate = $translate;
            this.UiPersistenceService = UiPersistenceService;
            this.AnalyticsService = AnalyticsService;
            this.AppStates = AppStates;
            this.UIUtils = UIUtils;
            this.$state = $state;
            this.onVisibilityToggle = this.onVisibilityToggle.bind(this);
            this.onCtaClick = this.onCtaClick.bind(this);

            this.LOCKED = Enums.leadsInsightsStates.locked;
            this.COLLECTING = Enums.leadsInsightsStates.collecting;
            this.RESULTS = Enums.leadsInsightsStates.results;

            this.persistenceHash = this.UiPersistenceService.getUiPersistence(
                this.UiPersistenceService.keys.pipelineLeadsInsights,
                { expanded: true }
            );

            this.state = this._getWidgetState();

            $scope.$watch(
                () => this.results,
                (newVal) => {
                    if (newVal) {
                        this.state = this._getWidgetState();
                    }
                }
            )
        }

        $onInit() {
            this.expanded = this.persistenceHash.expanded;
        }

        _getWidgetState() {
            // Show teaser for users with no active contact form
            if (this.user.isShowContactFormAwareness()) {
                this._setSeen(this.LOCKED);
                this._prepareResults(this.LOCKED)
                return this.LOCKED;
            }

            // Show results for users with results above threshold
            if (this.results && this.results.total.submissions_count >= MIN_SUBMISSION_COUNT) {
                this._setSeen(this.RESULTS);
                this._prepareResults(this.RESULTS);
                return this.RESULTS;
            }


            // Doesn't have results but does have active contact forms
            // Should see Collecting state if: saw teaser || saw results
           if (this.persistenceHash.seenTeaser || this.persistenceHash.seenResults) {
               return this.COLLECTING;
           }
        }

        _prepareResults(state) {
            // Prepare mock results
            if (state === this.LOCKED) {
                this.avgResponseTime = "2h";
                this.avgFormSubmission = "6%";
                this.mostPopularLeadSourcePercent = "56%";
                this.mostPopularLeadSource = "Facebook";
                this.percentOfInquiriesBooked = "32%";
                return;
            }

            // Prepare actual results
            const total = this.results.total;

            this.avgResponseTime = this.UIUtils.convertSecondsToHoursMinutes(
                total.average_first_response_time_in_sec || 0
            );
            this.avgFormSubmission = (total.submissions_count && total.views_count) ?
                `${(((total.submissions_count / total.views_count) * 100) || 0).toFixed(0)}%` :
                "0%";

            if (this.results.most_popular_lead_source) {
                this.mostPopularLeadSource = this.results.most_popular_lead_source;
                this.mostPopularLeadSourcePercent = `${this.results.most_popular_lead_source_percent || 0}%`;
            } else {
                this.mostPopularLeadSource = this.$translate.instant("LEADS_INSIGHTS._UNKNOWN_DATA_");
                this.mostPopularLeadSourcePercent = "0%";
            }

            this.percentOfInquiriesBooked = `${this.results.percent_of_inquiries_booked || 0}%`;
        }

        _setSeen(state) {
            // seenResults is for the case where user had results but doesn't any more
            // If that user has seenResults he should see the collecting state
            let value = state === this.LOCKED ? { seenTeaser: true} : { seenResults: true };

            this.UiPersistenceService.setUiPersistence(
                this.UiPersistenceService.keys.pipelineLeadsInsights,
                Object.assign(this.persistenceHash, value)
            );
        }


        onVisibilityToggle() {
            this.expanded = !this.expanded;

            if (!this.expanded) {
                this.AnalyticsService.trackClick(this, 'leads insights close insights');
            }
            
            this.UiPersistenceService.setUiPersistence(
                this.UiPersistenceService.keys.pipelineLeadsInsights,
                Object.assign(this.persistenceHash, { expanded: this.expanded })
            );
        }

        // Not implemented yet (currently commented out in leads_insights_insight)
        onCtaClick(ctaType) {
            if (ctaType === 'lead_source') {
                this.goToState(
                    this.AppStates.root_core_navigation_reports_analytics,
                    {section: 'lead_source'}
                );
            }
        }
    
    }

    Components.LeadsInsights = {
        bindings: {
            navigateToContactForm: '&',
            company: '<',
            user: '<',
            results: '<'
        },
        controller: LeadsInsightsController,
        templateUrl: 'angular/app/modules/core/features/pipeline/leads_insights/leads_insights_template.html',
    };

}());
